//
// Notion Javascript
//
//
// Vendors
import LazyLoad from "vanilla-lazyload";

// Modules
import SiteClock from './components/site-clock';

// Check if JS is on in browser, if so remove the `no-js` class from body
document.body.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.remove('preload');

  // Initialize Modules
  new SiteClock();

  // Init Lazy Load
  new LazyLoad();

}, false);